import React from 'react';
import IndexTableRow from '@lib/components/index-table/IndexTableRow';
import shortid from 'shortid';

export default class SparePartsFinderIndexTableRow extends IndexTableRow {
    renderIndexTableRow() {
        return (
            <React.Fragment>
                <tr key={shortid.generate()}
                    className="spare-part-finder-index-table-row index-table-expanded-row-row first">
                    {this.renderCheckbox()}
                    <td className="set-description" colSpan={this.props.columns.length}>
                        {this.renderDescriptionContainer()}
                    </td>
                    {this.renderActions()}
                </tr>
                {this.props.row.results.map((x, i) => this.renderRowInternal(x, i === this.props.row.results.length - 1))}
            </React.Fragment>
        )
    }

    createRowKey() {

        return this.props.row.id;
    }

    renderDescriptionContainer() {
        return (
            this.renderDescription()
        )
    }

    renderDescription() {
        return (
            <span className="description">{this.props.row.description}</span>
        )
    }

    renderActions() {
        return <React.Fragment/>
    }

    renderRowInternalActions() {
        return <React.Fragment/>
    }

    renderRowInternal = (row, isLast) => (
        <tr key={shortid.generate()} className={"index-table-expanded-row-row " + (isLast ? ' last' : '')}>
            <td></td>
            {this.props.columns.map((column, idx) => {
                return (
                    <React.Fragment key={idx}>
                        {this.renderDataCell(column, row[_.lowerFirst(column.slug)])}
                    </React.Fragment>
                )
            })}
            {this.renderRowInternalActions()}
        </tr>
    )
}